export function setEventTickets(state, eventTicketsData) {
    state.eventTicketsData = eventTicketsData;
}

export function setListEventTickets(state, listEventTickets) {
    state.listEventTickets = listEventTickets;
}